import { Box} from "@mui/material";
import AtomicButton from "../components/atoms/Button";
import AtomicTypography from "../components/atoms/Typography";
import AtomicAppBar from "../components/molecules/AppBar";
import "../styles/App.css";
import React, { useState } from "react";
import { DimensionType } from "../types/types";
import { RefetchCache, useCacheData } from "../utils/cache";
import CircularProgressBar from "../components/atoms/CircularProgressBar";
import { QueryClient } from "react-query";


const HomePage = () => {
  const [dimensions, setDimensions] = useState<DimensionType[]>([]);
  const [loading, setLoading] = useState(true);
  const queryClient = new QueryClient();
  // Use the useCacheData function to fetch data with caching
  const { data: dimensionsData, error: dimensionsError} = useCacheData<DimensionType[]>(
    "DimensionsData", // Key for caching
    "dimension", // URL to fetch data from
    Infinity // Time in seconds to cache data
  );

  React.useEffect(() => {
    // If dimensions data is present, set the state
    if (dimensionsData) {
      setDimensions(dimensionsData);
    } else if(!dimensionsData && !dimensionsError) {
      // If dimensions data is not present, fetch from the cache
      try {
        RefetchCache("DimensionsData", queryClient);
      } catch (error) {
        console.error("Error refetching DimensionsData:", error);
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setLoading(false); 
  }, [dimensionsData]);

  return (
    <>
      {loading ? (
        <CircularProgressBar />
      ) : (
        <div style={{ backgroundColor: "#2B5597", paddingBottom: "20px" }}>
          <AtomicAppBar />

          <AtomicTypography
            fontSize={"3.4rem"}
            color={"white"}
            align="center"
            className="home-title"
          >
            Welcome to the AI Maturity Assessment!
          </AtomicTypography>
          <Box
            sx={{
              padding: "20px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              maxWidth: "78%",
              height: "70%",
              margin: "2% 10%",
              backgroundColor: "white",
            }}
          >
            <AtomicTypography
              variant="h5"
              align="center"
              margin={"30px"}
              className="assesment-text"
            >
              This assessment will help you understand your organization’s AI
              maturity and where you
            <br /> can focus to improve in the future. We believe it can be the
            first step in guiding <br />
            your organization towards AI excellence.
            </AtomicTypography>

            <Box
              sx={{
                backgroundColor: "#45C2B1",
                borderRadius: "30px",
                padding: "1% 4%",
                margin: "1% 12%",
                width: "68%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
              }}
            >
              <AtomicTypography align="center" fontSize={"1.4rem"}>
                This AI maturity model explores 6 key dimensions to
              <br /> better understand your organization's AI landscape
              </AtomicTypography>
              <ul>
                {dimensions.map((dimension) => (
                  <li key={dimension.ID}>
                    <AtomicTypography
                      fontSize={"1.4rem"}
                      className="dimension-name"
                    >
                      {dimension.Name}
                    </AtomicTypography>
                  </li>
                ))}
              </ul>
            </Box>
          </Box>
          <AtomicTypography
            align="center"
            color={"white"}
            fontSize={"2rem"}
            className="home-text"
          >
{" "}
            Let's embark on this exciting journey of AI exploration!
          </AtomicTypography>
          <div className="btn-component">
            <AtomicButton text="Next" to={"/Dimensions"} />
          </div>
        </div>
      )}
    </>
  );
};

export default HomePage;
